var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnniversaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 2C24.4891 2 21.0844 2.68716 17.8802 4.04239C14.7844 5.35181 12.0037 7.22678 9.61522 9.61522C7.22678 12.0037 5.35181 14.7844 4.04239 17.8802C2.68716 21.0844 2 24.4891 2 28C2 31.5109 2.68716 34.9156 4.04239 38.1198C5.35181 41.2156 7.22678 43.9963 9.61522 46.3848C12.0037 48.7732 14.7844 50.6482 17.8802 51.9576C21.0844 53.3128 24.4891 54 28 54C31.5109 54 34.9156 53.3128 38.1198 51.9576C41.2156 50.6482 43.9963 48.7732 46.3848 46.3848C48.7732 43.9963 50.6482 41.2156 51.9576 38.1198C53.3128 34.9156 54 31.5109 54 28C54 24.4891 53.3128 21.0844 51.9576 17.8802C50.6482 14.7844 48.7732 12.0037 46.3848 9.61522C43.9963 7.22678 41.2156 5.35181 38.1198 4.04239C34.9156 2.68716 31.5109 2 28 2ZM28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.15 24C25.2778 22.5789 26.8567 19.2632 24.15 17.3684M26.5667 26.3684C30.1111 24 35.75 18.4105 29.95 15M29.95 29.2105C32.5278 25.2632 38.7467 18.0316 43 20.6842M32.85 32.0526C33.9778 30.1579 36.91 27.5053 39.6167 32.0526M29.3529 34.839L20.3464 26.8529C20.0834 26.6197 19.6682 26.7236 19.5459 27.0531L14.3994 40.9236C14.2474 41.3331 14.6568 41.7269 15.0601 41.5592L29.2131 35.6748C29.5539 35.5331 29.629 35.0838 29.3529 34.839Z",
    stroke: "#666666",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnniversaryIcon);
export default __webpack_public_path__ + "static/media/AnniversaryIcon.21f65dd323e26d82c5e3e99e2c7e7af1.svg";
export { ForwardRef as ReactComponent };